var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 418.06 428.44",
    width: "57px",
    height: "56px",
    style: {
      enableBackground: "new 0 0 418.06 428.44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.13,168.79c11.46-9.33,15.34-25.24,9.55-38.82l-34.29-80.26c-6.29-14.78-22.27-22.84-38.04-19.23l-74.6,17.32 C10.61,51.34,0,64.64,0,80.19c-0.21,192.83,155.85,348.46,348.25,348.25c15.56,0,28.85-10.61,32.39-25.74l17.32-74.6 c3.68-15.7-4.45-31.61-19.23-38.04l-80.26-34.29c-13.51-5.73-29.42-1.84-38.82,9.55l-27.51,33.59 c-43.63-23.12-79.48-58.97-102.6-102.6L163.13,168.79z M240.91,338.64l43.56-53.17c0.28-0.42,0.85-0.57,1.34-0.35l80.26,34.29 c0.49,0.21,0.78,0.78,0.64,1.34l-17.32,74.6c-0.14,0.57-0.64,0.92-1.2,0.92C173.24,396.55,31.82,254.99,32.03,80.12 c0-0.57,0.35-1.06,0.92-1.2l74.6-17.32c0.57-0.14,1.13,0.14,1.34,0.64l34.29,80.26c0.21,0.49,0.07,1.06-0.35,1.34l-53.17,43.56 C125.3,263.62,167.66,304.42,240.91,338.64z M242.23,64.25c-7.07-0.85-13.44,4.53-13.58,11.74l-0.14,8.06 c-0.14,6.08,4.31,11.38,10.32,12.16c43.2,5.73,77.15,39.67,82.8,82.8c0.78,6.01,6.08,10.47,12.16,10.32l8.06-0.14 c7.14-0.21,12.59-6.51,11.74-13.58C346.46,117.42,300.56,71.53,242.23,64.25z M242.94,0.04c-6.93-0.57-12.87,4.81-13.08,11.81 l-0.14,8.06c-0.14,6.36,4.6,11.67,10.96,12.23c77.22,6.93,138.24,68.09,145.24,145.24c0.57,6.22,5.94,11.03,12.23,10.96l8.06-0.14 c6.93-0.14,12.37-6.15,11.81-13.08C409.81,81.78,335.99,8.1,242.94,0.04L242.94,0.04z",
    fill: "#d14200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.06250e5cada0eadc42b2342d8a451df2.svg";
export { ForwardRef as ReactComponent };